module.exports = __webpack_public_path__ + "img/icon-cart.fff35a68.svg";